<template>
  <div>
    <myHeader />
    <div class="bg">
      <div class="contain">
        <div class="headcenter">
          <h1 style="font-size:26px">hecoos Mirror投影轨道镜</h1>
          <p style="font-size:12px">
            hecoos Mirror轨道镜拥有的投影画面控制能力灵活多变,
            突破固定投影机在画面投射方向上单一固定的局限。
          </p>
          <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</div>
          <!-- <div class="contain_button">
            <router-link to="/CaseDemonstration">
              <button class="contact-button">联系我们</button>
            </router-link>
          </div> -->
        </div>
      </div>
    </div>

    <div class="bg1">
      <div class="foundation_video">
        <div class="video_start">
          <h1>点亮新视野</h1>
          <button class="watch-movie-button " @click="showVideo">
            <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
          </button>
        </div>
        <video autoplay loop muted playsinline webkit-playsinline x5-playsinline x-webkit-airplay="allow"
          src="https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4"></video>
      </div>
    </div>

    <div class="bg2">
      <div class="bg22">
        <p>硬件规格</p>
        <h1>参数细细看</h1>
        <img src="../../../asset/mobile/mobile_projectorbit/parameter.png" />
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="bg3">
      <div>
        <div class="con11">
          <h1>规则参数</h1>
        </div>
        <div class="contain1">
          <div class="con1">
            <p>设备尺寸(W/D/H):</p>
            <p>设备总重量:</p>
            <p>投影机重量:</p>
            <p>单镜子重量:</p>
            <p>桁架安装架MHZ-BT重量:</p>
            <p>壁挂式安装架MHZ-BW重量:</p>
            <p>扩展安装架MHZ-BE重量:</p>
            <p>落地架MHZ-BSH重量:</p>
          </div>
          <div class="con2">
            <p>{{ specParams.deviceSize }}</p>
            <p>{{ specParams.totalWeight }}</p>
            <p>{{ specParams.projectorWeight }}</p>
            <p>{{ specParams.mirrorWeight }}</p>
            <p>{{ specParams.btMountWeight }}</p>
            <p>{{ specParams.bwMountWeight }}</p>
            <p>{{ specParams.beMountWeight }}</p>
            <p>{{ specParams.bshMountWeight }}</p>
          </div>
        </div>
      </div>

      <div class="content2">
        <div class="con11">
          <h1>电器规格</h1>
        </div>
        <div class="contain1">
          <div class="con1">
            <p>输入功率:</p>
            <p>输出功率：</p>
          </div>
          <div class="con2">
            <p>{{ electricSpecs.inputPower }}</p>
            <p>{{ electricSpecs.outputPower }}</p>
          </div>
        </div>
      </div>
      <div class="content3">
        <div class="con11">
          <h1>操作规格</h1>
        </div>

        <div class="contain1">
          <div class="con1">
            <p>轨道镜倾斜模式：</p>
            <p>轨道镜平移模式:</p>
            <p>定位精准度误差：</p>
            <p>移动模式精度：</p>
          </div>
          <div class="con2">
            <p>{{ operationSpecs.tiltMode }}</p>
            <p>{{ operationSpecs.panMode }}</p>
            <p>{{ operationSpecs.positionError }}</p>
            <p>{{ operationSpecs.movementPrecision }}</p>
          </div>
        </div>
      </div>
      <div class="content4">
        <div class="con11">
          <h1>运行环境</h1>
        </div>

        <div class="con1">
          <p>工作环境温度范围:5°-35°C</p>
          <p>湿度:20%-80%(无冷凝)</p>
        </div>
        <div class="con2"></div>
      </div>
      <div class="content5">
        <div class="con11">
          <h1>提供附件</h1>
        </div>
        <div class="con1">
          <p>RS232连接线</p>
          <p>交流回路电缆</p>
          <p>快速安装指南</p>
        </div>
        <div class="con2"></div>
      </div>
    </div>
    <!-- 作品部分 -->
    <div class="bg4">
      <div>
        <div class="foundation_video">

          <video autoplay loop muted playsinline webkit-playsinline x5-playsinline x-webkit-airplay="allow"
            src="https://download.hecoos.com/enlightv/2025-17/4339ee88fdfb051af80a4a26f1830572.mp4"></video>
          <div class="video_start">
            <button class="watch-movie-button" @click="showVideo2">
              <img src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <myInquire />
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import myInquire from "@/components/mobile/myInquire.vue";
import videoPlayback from "@/components/mobile/videoPlayback.vue";
export default {

  components: { myFooter, myHeader, myInquire, videoPlayback },
  data() {
    return {
      videoUrl: '',
      showVideoPlayer: false,
      specParams: {
        deviceSize: "498mmx265mmx749mm",
        totalWeight: "25.8kg",
        projectorWeight: "16.3kg",
        mirrorWeight: "9.3kg",
        btMountWeight: "2.2kg",
        bwMountWeight: "2.8kg",
        beMountWeight: "3.3kg",
        bshMountWeight: "12.5Kg",
      },
      electricSpecs: {
        inputPower: "100-240V/2-1A/50-60Hz，最大10A(+C14插座)",
        outputPower: "投影机交流回路槽(3针C13母插口)",
      },
      operationSpecs: {
        tiltMode: "90度和162度",
        panMode: "180度",
        positionError: "<0.03°",
        movementPrecision: "同一方向平移或倾斜到设定好的位置，误差在0.01左右",
      },
      environmentSpecs: {
        temperatureRange: "5°-35°C",
        humidity: "20%-80%(无冷凝)",
      },
      textaerass: {
        titletext: "《致敬生命拯救者》光影行为艺术",
        pagetext:
          "2021新年伊始，在天津广播电视塔2021跨年灯光秀上，一场4分30秒的“光影行为艺术”《致敬生命拯救者》在天津广播电视塔上呈现了一个唯美又惊心动魄的故事。在呈现过程中，主创团队使用hecoos Mirror与Server-R媒体服务器配合保障作品的呈现。画面最高点在现场呈现时，主创团队使用轨道镜、高流明工程投影仪、hecoos全域媒体创作平台等前沿的硬软体媒介来保证实验过程与现场呈现的真实度。投影机配载自主编程的轨道镜系统进行建筑体投射，画面最高点达260米，也使得这件作品成为在投射范围、设备使用极简性上的一件代表性投影作品。",
      },
      formData: {
        name: "",
        phone: "",
        city: "",
        email: "",
        company: "",
        position: "",
        message: "",
      },
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      // 在此处添加表单提交后的处理逻辑，例如发送数据到服务器
      console.log(this.formData);
    },
    // 显示视频播放器
    showVideo() {
      this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/639b0bf986e055fad0427e2ebd9c95ef.mp4",
        this.showVideoPlayer = true;
      console.log(1);
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    showVideo2() {
      this.videoUrl = "https://download.hecoos.com/enlightv/2025-11/f441eac9aa01246106ff61af11ddefd5.mp4",
        this.showVideoPlayer = true;
      console.log(2);
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
     jumpTo(url) {
      this.$router.push(url);
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
  },
};
</script>


<style lang="scss" scoped>
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      color: white;
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
@media screen and (min-width: 768px){

  .headcenter h1{
    font-size: 50px !important;

  }
  .headcenter p{
    font-size: 20px !important;
  }
  .bg {
  background: black;
  background-image: url("../../../asset/mobile/mobile_projectorbit/hero.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

option {
  font-size: 12px;
  /* 对选中的<option>设置文字大小 */
}

.bg p {
  font-size: 14px;
  line-height: 25px;
}

select#city option {
  font-size: 12px;
}

.contact-button {
  background-color: white;
  /* 白色背景 */
  border: none;
  border-radius: 20px;
  /* 圆角效果 */
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  /* 阴影效果 */
}

.contact-button:hover {
  background-color: black;
  color: white;
  transform: scale(1.05);
}

.contain {
  padding: 0px 43px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  height: 36vh;
}

.contain h1 {
  font-size: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;

}

.contain p {
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  font-family: YourFontName2;
}

.contain_button {
  display: flex;
  justify-content: center;
}

.bg1 {
  background-color: black;
  text-align: center;

}

.bg1 video {
  width: 100%;
}

.bg1 img {
  width: 100%;
}

.bg2 img {
  width: 100%;
}

.bg1 h1 {
  font-size: 26px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;

}

.bg2 {
  background-color: black;
  text-align: left;
  padding: 20px 43px;
}

.bg2 p {
  color: white;
  font-size: 26px !important;
  padding: 5px 0;
}

.bg2 h1 {
  color: white;
  font-size: 45px !important;
}

.bg3 {
  /* background-image: url("../../../asset/mobile/mobile_projectorbit/rectangle.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; */
  background-color: black;
  padding: 20px 43px;
}

.bg3 p {
  line-height: 25px;
  font-size: 20px !important;
  line-height: 25px !important; 
}

.bg4 {
  background: black;
  text-align: center;
  padding: 20px 0px;
}

.bg4 h1 {
  font-size: 26px;
  color: white;
  text-align: center;
}

.qq {
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  color: white;
  padding: 10px 43px;

  margin: 0 auto;
}

.qq1 {
  margin: 0 auto;
}

.qq1 p {
  font-family: YourFontName2;
}

.bg4text p {
  text-align: left;
  color: white;
  margin: 0 auto;
  font-size: 12px;

  line-height: 20px;
  padding: 10px 43px;
}

.bg4text video {
  width: 100%;
  padding: 0px 43px;
}

.contain1 {
  display: flex;
  justify-content: left;
  padding-bottom: 20px;
}

.con11 {
  color: white;
  border-top: 1px solid white;
  padding: 20px 0px;
}

.con11 h1 {
  font-size: 26px !important;
  font-family: YourFontName2;
}

.con1 {
  color: white;
  font-weight: bold;
  width: 50%;
}

.content4 {
  padding-bottom: 20px;
}

.con1 p {
  font-family: YourFontName2;
  font-size: 9px;
  line-height: 15px;
}

.contain {
  display: flex;
  justify-content: center;
}

.con2 {
  color: #a6a6a6;
}

.con2 p {
  font-family: YourFontName2;
  color: rgba(166, 166, 166, 1);
  line-height: 15px;
  font-size: 9px;
}

.contact-form {
  color: #fff;
  text-align: center;
}

.form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}

.form-row select::placeholder {
  color: #ffffff;
  font-size: 8px;
}

.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}

.form-row input::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 5px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #147cf5;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}

.contact-form h1 {
  font-size: 26px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  padding: 0px 43px;
}

.contact-form p {
  font-size: 12px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}

.bg5 {
  background: black;
  padding: 20px 43px;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;
  object-fit: cover;

}

.watch-movie-button {
  width: 50px !important;
  height: 50px !important;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;
  h1{
    font-size: 45px !important;
  }

}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}

}
.bg {
  background: black;
  background-image: url("../../../asset/mobile/mobile_projectorbit/hero.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

option {
  font-size: 12px;
  /* 对选中的<option>设置文字大小 */
}

.bg p {
  font-size: 14px;
  line-height: 25px;
}

select#city option {
  font-size: 12px;
}

.contact-button {
  background-color: white;
  /* 白色背景 */
  border: none;
  border-radius: 20px;
  /* 圆角效果 */
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  /* 阴影效果 */
}

.contact-button:hover {
  background-color: black;
  color: white;
  transform: scale(1.05);
}

.contain {
  padding: 0px 43px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  height: 36vh;
}

.contain h1 {
  font-size: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;

}

.contain p {
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  font-family: YourFontName2;
}

.contain_button {
  display: flex;
  justify-content: center;
}

.bg1 {
  background-color: black;
  text-align: center;

}

.bg1 video {
  width: 100%;
}

.bg1 img {
  width: 100%;
}

.bg2 img {
  width: 100%;
}

.bg1 h1 {
  font-size: 26px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;

}

.bg2 {
  background-color: black;
  text-align: left;
  padding: 20px 43px;
}

.bg2 p {
  color: white;
  font-size: 14px;
  padding: 5px 0;
}

.bg2 h1 {
  color: white;
  font-size: 26px;
}

.bg3 {
  /* background-image: url("../../../asset/mobile/mobile_projectorbit/rectangle.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover; */
  background-color: black;
  padding: 20px 43px;
}

.bg3 p {
  line-height: 25px;
  font-size: 14px;
}

.bg4 {
  background: black;
  text-align: center;
  padding: 20px 0px;
}

.bg4 h1 {
  font-size: 26px;
  color: white;
  text-align: center;
}

.qq {
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  color: white;
  padding: 10px 43px;

  margin: 0 auto;
}

.qq1 {
  margin: 0 auto;
}

.qq1 p {
  font-family: YourFontName2;
}

.bg4text p {
  text-align: left;
  color: white;
  margin: 0 auto;
  font-size: 12px;

  line-height: 20px;
  padding: 10px 43px;
}

.bg4text video {
  width: 100%;
  padding: 0px 43px;
}

.contain1 {
  display: flex;
  justify-content: left;
  padding-bottom: 20px;
}

.con11 {
  color: white;
  border-top: 1px solid white;
  padding: 20px 0px;
}

.con11 h1 {
  font-size: 17px;
  font-family: YourFontName2;
}

.con1 {
  color: white;
  font-weight: bold;
  width: 50%;
}

.content4 {
  padding-bottom: 20px;
}

.con1 p {
  font-family: YourFontName2;
  font-size: 12px;
  line-height: 20px;
}

.contain {
  display: flex;
  justify-content: center;
}

.con2 {
  color: #a6a6a6;
}

.con2 p {
  font-family: YourFontName2;
  color: rgba(166, 166, 166, 1);
  line-height: 20px;
  font-size: 12px;
}

.contact-form {
  color: #fff;
  text-align: center;
}

.form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}

.form-row select::placeholder {
  color: #ffffff;
  font-size: 8px;
}

.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}

.form-row input::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 5px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #147cf5;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}

.contact-form h1 {
  font-size: 26px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  padding: 0px 43px;
}

.contact-form p {
  font-size: 12px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}

.bg5 {
  background: black;
  padding: 20px 43px;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;
  object-fit: cover;

}

.watch-movie-button {
  width: 32px;
  height: 32px;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;


}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}

</style>